import React from 'react'
//images
import SlideOne from '../../assets/images/about.webp'
import SlideTwo from '../../assets/images/about1.webp'
import SlideThree from '../../assets/images/about2.webp'
import SlideFour from '../../assets/images/about3.webp'


const AboutUs = () => {
  return (
    <article className="about__company">
      <section className="about__company__content">
        <h2>Über uns</h2>
        <h3 className='sub-title'>Mehr als nur großartige Pizza</h3>
        <p>
        Seit 2019 definieren wir das Pizza-Erlebnis neu – Stück für Stück. Unser Erfolg basiert auf Leidenschaft für Qualität, einem tiefen Verständnis dafür, was unsere Kunden lieben, und dem Anspruch, unvergessliche Geschmackserlebnisse zu liefern. Von unseren frischen Zutaten bis hin zu unserem innovativen Markenauftritt wird jedes Detail mit höchster Sorgfalt gestaltet.  
        <br /><br />
        Bei Casaantonio e piccolo gió servieren wir nicht einfach nur Pizza – wir schaffen Momente. Mit zentralen Standorten, einem unkomplizierten Online-Bestellsystem und anpassbaren Vorbestelloptionen machen wir es so einfach wie nie, deine Lieblingspizza zu genießen. Ob entspanntes Abendessen, besondere Feier oder Firmenevent – wir bringen Menschen durch die Liebe zum guten Essen zusammen.  
        <br /><br />
        Denn bei Casaantonio e piccolo gió bist du nicht nur ein Kunde – du bist Teil unserer Geschichte. 
        <br /><br />
      </p>
        <div className="about__company__glass"></div>
      </section>
      <section className="about__company__gallery">
        <img src={SlideOne} alt="" aria-hidden="true" />
        <img src={SlideTwo} alt="" aria-hidden="true" />
        <img src={SlideThree} alt="" aria-hidden="true" />
        <img src={SlideFour} alt="" aria-hidden="true" />
      </section>
    </article>
  )
}

export default AboutUs;